// CarouselResponsiveUtils.js
define('CarouselResponsiveUtils', [], function () {
    'use strict';

    function getCarouselSettings(windowWidth) {
        var maxSlides = 5;
        var slideWidth = 265;

        if (windowWidth >= 992 && windowWidth <= 1366) {
            if (windowWidth <= 1200) {
                maxSlides = 4;
                slideWidth = 230;
            } else {
                maxSlides = 6;
                slideWidth = 277;
            }
        }
        if (windowWidth >= 1366 && windowWidth <= 1500) {
            maxSlides = 6;
            slideWidth = 295;
        }
        else if (windowWidth >= 1600 && windowWidth <= 1799) {
            maxSlides = 6;
            slideWidth = 275;
        }
        else if (windowWidth >= 1800) {
            maxSlides = 6;
            slideWidth = 295;
        }

        return {
            maxSlides: maxSlides,
            slideWidth: slideWidth
        };
    }

    return {
        getCarouselSettings: getCarouselSettings
    };
});
